export default __webpack_public_path__ + "static/media/claimsCardIcon.ca144dab.svg";